import dayjs from 'dayjs';

const spanIncludesFutureDays = (startDate, scheduleFormat) => {
  let lastDay = dayjs(startDate).add(scheduleFormat - 1, 'day').startOf('day');
  return lastDay.isAfter(dayjs().startOf('day'));
}

export default spanIncludesFutureDays;
